// extracted by mini-css-extract-plugin
export default {"transition":"containers_transition__D8J9y"};